module.exports = __webpack_public_path__ + "img/txdk.ba792bb0.svg";